import React from "react";
import "./styles/skill.css";
import python from "./assets/langicons/python.png";
import django from "./assets/langicons/django.png";
import javascript from "./assets/langicons/javascript.png";
import typescript from "./assets/langicons/typescript.png";
import react from "./assets/langicons/react.png";
import node from "./assets/langicons/node.png";
import express from "./assets/langicons/express.png";
import rust from "./assets/langicons/rust.png";
import docker from "./assets/langicons/docker.png";
import mongodb from "./assets/langicons/mongodb.png";
import mysql from "./assets/langicons/mysql.png";
import sqlite from "./assets/langicons/sqlite.png";
import redis from "./assets/langicons/redis.png";
import locust from "./assets/langicons/locust.png";
import postgres from "./assets/langicons/postgres.png"

// Python Django Javascript Typescript ReactJS NodeJS ExpressJS Rust

const theskills = [
  { name: "Python", img: python },
  { name: "Django", img: django },
  { name: "Javascript", img: javascript },
  { name: "Typescript", img: typescript },
  { name: "Rust", img: rust },

  { name: "ReactJS", img: react },
  { name: "NodeJS", img: node },
  { name: "ExpressJS", img: express },
  
  { name: "MongoDB", img : mongodb},
  { name: "MySQL", img : mysql},
  { name: "SQLite", img : sqlite},
  { name: "Redis", img : redis},
  { name: "Postgres", img : postgres},

  { name: "Docker", img : docker},
  { name: "Locust", img : locust},
];

const Skill = () => {
  return (
    <>
      <div className="lang-container">
        {theskills.map((skill, index) => (
          <div className="wrapper-cards" key={index}>
            <div className="lang-cards">
              <img src={skill.img} alt={skill.name} />
            </div>
            <p>{skill.name}</p>
          </div>
        ))}
      </div>
      <div className="coursework">
        <h3>Relevant Coursework</h3>
        <ul>
          <li>Software Engineering</li>
          <li>Database Management System</li>
          <li>Network Programming</li>
          <li>Data Structures And Algorithms</li>
          <li>Design And Analysis of Algorithms</li>
        </ul>
      </div>
    </>
  );
};

export default Skill;
